import { render } from "./PurchaseView.vue?vue&type=template&id=4f7321da&ts=true"
import script from "./PurchaseView.vue?vue&type=script&lang=ts"
export * from "./PurchaseView.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/TCD-GIFTSHOP-CHANNELING-FRONT/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__